<template>
  <div class="and-or-template col-xs-12 clearfix" :class="isFirst ? 'and-or-first' : '' ">
    <div class="form-group and-or-top col-xs-12">
      <div 
        v-show="!disableOr"
        class="col-xs-11" 
        style="padding: 0">
        <b-form-radio-group 
          v-model="isAnd" 
          @input="emitChangedStatement">
          <b-form-radio :value="true">AND</b-form-radio>
          <b-form-radio :value="false">OR</b-form-radio>
        </b-form-radio-group>
      </div>
      <div class="col-xs-1 btn-and-or">
        <button 
          v-if="!isFirst" 
          class="btn btn-sm btn-purple pull-right" 
          @click.prevent="deleteSelf()">
          x
        </button>
      </div>
    </div>

    <div v-draggable="{handle: '.handle'}">
      <rule
        v-for="(rule, index) in rules" ref="rules"
        :key="rule.id"
        :options="options"
        :rule="rule"
        :enableRuleName="enableRuleName"
        :isComputedExpression="isComputedExpression"
        :isHidable="isHidableRule"
        @delete-rule="deleteRule(index)"
        @change-rule="emitChangedStatement">
      </rule>
    </div>

    <and-or
      class="and-or-offset col-xs-11"
      v-for="(group, index) in groups" ref="groups"
      :key="group.id"
      :group="group"
      :options="options" 
      :enableRuleName="enableRuleName"
      :isComputedExpression="isComputedExpression"
      :isHidableRule="isHidableRule"
      @delete-group="deleteGroup(index)"
      @change-statement="emitChangedStatement">
    </and-or>

    <div class="col-xs-12">
      <button 
        v-show="!disableGroups"
        class="btn btn-xs btn-success btn-sm" 
        @click.prevent="addGroup">
         + ( group ) 
      </button>
      <button 
        class="btn btn-xs btn-success btn-sm add-rule" 
        @click.prevent="addRule">
         + add 
      </button>
      <button 
        class="btn btn-xs btn-success btn-sm add-rule" 
        @click.prevent="save">
         save
      </button>
    </div>
  </div>
</template>

<script>
  import Rule from './Rule'

  export default {
    name: 'andOr',
    components: {
      Rule
    },
    props: {
      options: {
        type: Object,
        required: true
      },
      enableRuleName: {
        type: Boolean,
        default: false,
        required: false
      },
      disableGroups: {
        type: Boolean,
        default: false,
        required: false
      },
      disableOr: {
        type: Boolean,
        default: false,
        required: false
      },
      isFirst: {
        type: Boolean,
        default: false
      }, 
      isComputedExpression: {
        type: Boolean,
        default: false
      },
      isHidableRule: {
        type: Boolean,
        default: false
      },
      group: {
        type: Object
      },
    },
    mounted () {
      if (this.group && this.group.rules) {
        const rules =  this.group.rules.map(r => ({...r, id: r.id || this.generateId()}))
        this.rules = rules.filter(r => !r.condition);
        this.groups = rules.filter(r => r.condition);
        this.isAnd = this.group.condition === 'AND';
      } else {
        this.addRule();
      }
    },
    data () {
      return {
        isAnd: true,
        groups: [],
        rules: []
      }
    },
    methods: {
      save() {
        this.$emit('change-statement');
      },
      addRule () {
        var id = this.generateId();
        this.rules.push(id);
      },

      addGroup () {
        var id = this.generateId();
        this.groups.push({id});
      },

      deleteSelf () {
        this.$emit('delete-group');
        this.save();
      },

      deleteRule (index) {
        this.rules.splice(index, 1);
        this.save();
      },

      emitChangedStatement () {
        //this.$emit('change-statement');
      },

      deleteGroup (index) {
        this.groups.splice(index, 1);
        this.save();
      },

      queryFormStatus () {
        var query = {};
        var rules = this.$refs.rules || {};

        if (rules.sort) {
          rules.sort(({$el: el1}, {$el:el2}) => this.elementIndex(el1) - this.elementIndex(el2));
        }

        var groups = this.$refs.groups || {};
        var i, j;

        query['condition'] = this.isAnd ? 'AND' : 'OR';
        query['rules'] = [];
        for(i = 0; i < rules.length; i++){
          query.rules.push(rules[i].queryFormStatus ());
        }
        for(j = 0; j < groups.length; j++){
          query.rules[query.rules.length] = groups[j].queryFormStatus();
        }
        return query;
      },

      generateId () {
        return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
          return v.toString(16);
        });
      },

      elementIndex(element) {
        let i = 0;
        while ((element = element.previousSibling) != null) {
          i++
        }
        return i;
      },

      changedRuleValue(rule, value) {
        rule.expression = false;
        rule.value = value;
        this.emitChangeRule();
      },
    }
  }
</script>

<style lang="scss">
  .and-or-template {
    padding: 8px;
    position: relative;
    border-radius: 3px;
    border: 1px solid #6d77b8;
    border-top: 3px solid #d2d6de;
    margin-bottom: 20px;
    /* width: 100%; */
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
    border-top-color: #6d77b8;
    background-color: rgba(255, 255, 255, 0.9);
  }

  .and-or-template:before,
  .and-or-template:after {
    content: '';
    position: absolute;
    left: -17px;
    width: 16px;
    height: calc(50% + 18px);
    border-color: #c0c5e2;
    border-style: solid;
  }

  .and-or-template:before {
    top: -18px;
    border-width: 0 0 2px 2px;
  }

  .and-or-template:after {
    top: 50%;
    border-width: 0 0 0 2px;
  }

  .and-or-first:before,
  .and-or-first:after,
  .and-or-template:last-child:after {
    border: none;
  }

  .and-or-top,
  .btn-and-or {
    padding: 0;
  }

  .btn-and-or button {
    margin-left: 4px;
  }

  .and-or-offset {
    margin-left: 30px;
  }


  .and-or-template {
    flex-direction: column;
    .col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-xs-1,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9 {
        position: relative;
        min-height: 1px;
        padding-right: 15px;
        padding-left: 15px
    }

    .col-xs-1,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9 {
       display: flex;
    }

    .col-xs-12 {
        width: 100%
    }

    .col-xs-11 {
        width: 91.66666667%
    }

    .col-xs-10 {
        width: 83.33333333%
    }

    .col-xs-9 {
        width: 75%
    }

    .col-xs-8 {
        width: 66.66666667%
    }

    .col-xs-7 {
        width: 58.33333333%
    }

    .col-xs-6 {
        width: 50%
    }

    .col-xs-5 {
        width: 41.66666667%
    }

    .col-xs-4 {
        width: 33.33333333%
    }

    .col-xs-3 {
        width: 25%
    }

    .col-xs-2 {
        width: 16.66666667%
    }

    .col-xs-1 {
        width: 8.33333333%
    }
    &.clearfix::after,
    .clearfix::after {
      content: "";
      clear: both;
      display: table;
    }
  }


</style>
